import React from 'react';
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'
import {hydrate} from 'react-dom'
import PropTypes from 'prop-types';

import externalService from './external-service';

import Loading from '../../loading/loading'

import './external.styl'
class External extends React.Component {
    static propTypes = {
        url: PropTypes.string,
    }

    static contextTypes = {
        store: PropTypes.object.isRequired
    }

    state = {
        html: false,
        locale: 'en'
    }

    UNSAFE_componentWillMount() {
        this.state.locale = this.context.store.app.locale
    }

    componentDidMount () {
        // this.refs.external.getDOMNode().addEventListener('load', this.onLoad);
        this.refs.external.addEventListener("load", this.onLoad);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.locale !== this.state.locale) this.setState({state: nextProps.locale})
    }

    onLoad(data) {
        console.log('onLoad', data);
        const node = this.refs.external;
        const nodeChild = node.contentWindow.document.body
        node.style.height = nodeChild.offsetHeight + 'px';
        node.style.width = nodeChild.offsetWidth + 'px';
    }

    render() {
        // const {html} = this.state
        // if(!html) return <Loading printable={true} />
        return <iframe className='external' ref="external" src={this.props.url + '?locale=' + this.state.locale}/>;
    }
}

const mapStateToProps = state => {
    const {locale} = state.langReducers
    return {locale}
}
export default connect(mapStateToProps)(External)
